<style>
#displaySettingsModal .v--modal-box.v--modal {
  min-height: 375px !important;
  min-width: 360px !important;
}
#displaySettingsModal .modal__footer {
  display: none;
}
#displaySettingsModal .modal__content {
  margin-top: -65px;
  overflow-y: auto !important;
}
.buttons--button {
  text-align: center;
  cursor: pointer;
  height: 24px;
}
.buttons__container {
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  border: 1px solid lightgrey;
}
#displaySettingsModal .display__parameters {
  height: 100%;
  align-items: center;
  justify-content: center;
}
#displaySettingsModal .list--el:last-child {
  border-bottom: none;
}
#displaySettingsModal .v-tabs__container {
  justify-content: center;
  margin-bottom: 10px;
}
#displaySettingsModal .settings--input {
  text-align: right;
  border-bottom: 1px solid lightgray;
}
.list--el:hover {
  background: #e7e7e7;
}
</style>

<template>
  <Modal
    modalName="displaySettingsModal"
    title="Ustawienia wyświetlania"
    :buttons="[]"
    @opened="opened"
  >
    <div>
      <v-tabs
        v-model="activeTab"
        slider-color="grey"
      >
        <v-tab>Węzły</v-tab>
        <v-tab>Odcinki</v-tab>
        <v-tab>Etykiety</v-tab>
        <!--<v-tab>Symbole</v-tab>
        <v-tab>Strzałka kierunku</v-tab>-->

        <v-tab-item>
          <v-layout class="display__parameters">
            <v-list
              subheader
              style="width: 100%"
            >
              <v-list-tile class="list--el">
                <v-list-tile-content xs2>
                  <v-list-tile-title>Wielkość węzła</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <input
                    class="settings--input"
                    type="number"
                    min="1"
                    autofocus
                    v-model="settings.nodes.size"
                  >
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content @click="settings.nodes.display = !settings.nodes.display">
                  <v-list-tile-title>Wyświetlaj węzły</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.nodes.display"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content @click="settings.nodes.sizeProportions = !settings.nodes.sizeProportions">
                  <v-list-tile-title>Wielkość proporcjonalna do wartości</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.nodes.sizeProportions"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <!--<v-list-tile class="list--el">
                <v-list-tile-content
                  @click="settings.nodes.displayContour = !settings.nodes.displayContour"
                >
                  <v-list-tile-title>Wyświetl obrys</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.nodes.displayContour"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>-->
            </v-list>
          </v-layout>
        </v-tab-item>
        <v-tab-item>
          <v-layout class="display__parameters">
            <v-list
              subheader
              style="width: 100%"
            >
              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Szerokość odcinka</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <input
                    class="settings--input"
                    type="number"
                    min="1"
                    autofocus
                    v-model="settings.links.width"
                  >
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content @click="settings.links.display = !settings.links.display">
                  <v-list-tile-title>Wyświetlaj odcinki</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.links.display"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content @click="settings.links.sizeProportions = !settings.links.sizeProportions">
                  <v-list-tile-title>Wielkość proporcjonalna do wartości</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.links.sizeProportions"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-layout>
        </v-tab-item>
        <v-tab-item>
          <p v-if="currentZoom <= 16">Etykiety widoczne od 17 zoomu, przybliż aby zobaczyć</p>
          <v-layout class="display__parameters">
            <v-list
              subheader
              style="width: 100%"
            >
              <v-list-tile class="list--el">
                <v-list-tile-content @click="settings.labels.displayNodesID = !settings.labels.displayNodesID">
                  <v-list-tile-title>Wyświetlaj ID węzłów</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.labels.displayNodesID"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content @click="settings.labels.displayNodesValues = !settings.labels.displayNodesValues">
                  <v-list-tile-title>Wyświetlaj wartości w węzłach</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.labels.displayNodesValues"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content @click="settings.labels.displayLinksID = !settings.labels.displayLinksID">
                  <v-list-tile-title>Wyświetlaj ID odcinków</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.labels.displayLinksID"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content @click="settings.labels.displayLinksValues = !settings.labels.displayLinksValues">
                  <v-list-tile-title>Wyświetlaj wartości w odcinkach</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.labels.displayLinksValues"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-layout>
        </v-tab-item>
        <!--<v-tab-item>
          <v-layout class="display__parameters">
            <v-list subheader style="width: 100%">
              <v-list-tile class="list--el">
                <v-list-tile-content
                  @click="settings.symbols.displayReservoirs = !settings.symbols.displayReservoirs"
                >
                  <v-list-tile-title>Wyświetlaj zbiorniki</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.symbols.displayReservoirs"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content
                  @click="settings.symbols.displayPumps = !settings.symbols.displayPumps"
                >
                  <v-list-tile-title>Wyświetlaj pompy</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.symbols.displayPumps"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content
                  @click="settings.symbols.displayValves = !settings.symbols.displayValves"
                >
                  <v-list-tile-title>Wyświetlaj zasuwy</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.symbols.displayValves"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content
                  @click="settings.symbols.displayOutflow = !settings.symbols.displayOutflow"
                >
                  <v-list-tile-title>Wyświetlaj wypływy</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.symbols.displayOutflow"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content
                  @click="settings.symbols.displaySource = !settings.symbols.displaySource"
                >
                  <v-list-tile-title>Wyświetlaj źródło jakości wody</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.symbols.displaySource"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content
                  @click="settings.symbols.displayProjectedReceivers = !settings.symbols.displayProjectedReceivers"
                >
                  <v-list-tile-title>Wyświetlaj projektowanych odbiorców</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.symbols.displayProjectedReceivers"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-layout>
        </v-tab-item>
        <v-tab-item>
          <v-layout class="display__parameters">
            <v-list subheader style="width: 100%">
              <v-list-tile class="list--el">
                <v-list-tile-content @click="settings.arrow.displayArrow = !nodes.sizeProportions">
                  <v-list-tile-title>Wyświetl strzałkę kierunku przepływu</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-checkbox v-model="settings.arrow.displayArrow"></v-checkbox>
                </v-list-tile-action>
              </v-list-tile>
              <v-list-tile class="list--el">
                <v-list-tile-content>
                  <v-list-tile-title>Wielkość strzałki</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <input
                    class="settings--input"
                    type="text"
                    autofocus
                    v-model="settings.arrow.size"
                  >
                </v-list-tile-action>
              </v-list-tile>
            </v-list>
          </v-layout>
        </v-tab-item>-->
      </v-tabs>
    </div>
    <div>
      <v-subheader>Legenda</v-subheader>
      <template v-if="!!editLegendType">
        <v-subheader style="font-size: 14px !important">Edycja {{editLegendType == 'nodes' ? 'włęzły' : 'odcinków'}} dla atrybutu '{{attributes[editLegendType][editLegendData.attribute]}}'</v-subheader>
        <div>
          <v-container
            grid-list-md
            text-xs-center
          >
            <v-layout row>

              <v-flex xs2>
                <v-layout
                  fill-height
                  column
                  justify-space-between
                >
                  <template v-for="row in editLegendValue">
                    <v-flex d-flex>
                      <v-card
                        dark
                        :color="row.color"
                      >
                        <v-card-text class="px-0">&nbsp;</v-card-text>
                      </v-card>
                    </v-flex>
                  </template>
                </v-layout>
              </v-flex>

              <v-flex xs10>
                <v-layout
                  fill-height
                  column
                  justify-space-between
                >
                  <template v-for="(row,index) in editLegendValue">
                    <v-flex
                      d-flex
                      v-if="index != editLegendValue.length - 1"
                    >
                      <v-card>
                        <v-card-text class="py-3">
                          <v-text-field
                            v-model="row.value"
                            type="number"
                            flat
                            hide-details
                            class="pt-0"
                          ></v-text-field>
                        </v-card-text>
                      </v-card>
                    </v-flex>
                  </template>
                </v-layout>
              </v-flex>

            </v-layout>
          </v-container>
        </div>
        <v-btn
          small
          @click="saveLegend"
          color="primary"
        >
          <v-icon dark>save</v-icon> zapisz stylizację
        </v-btn>
      </template>
      <template v-else>
        <div v-if="!!displaySettings.last_model">
          <div v-if="nodesLegend.length > 0">
            <div class="text-xs-center">
              <v-subheader style="font-size: 14px !important">
                <span>Węzły</span>
                <template v-if="displaySettings.nodes.attribute !== 'null'">
                  <v-btn
                    flat
                    fab
                    small
                    title="utwórz ręczną stylizację"
                    @click="editLegend('nodes')"
                  >
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  <v-btn
                    flat
                    fab
                    small
                    title="wyczyść ręczną stylizację"
                    @click="clearLegend('nodes')"
                  >
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                </template>
              </v-subheader>
            </div>
            <v-container
              grid-list-md
              text-xs-center
            >
              <v-layout
                row
                wrap
              >
                <template v-for="row in nodesLegend">
                  <v-flex xs2>
                    <v-card
                      dark
                      :color="row.color"
                    >
                      <v-card-text class="px-0 py-1">&nbsp;</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs10>
                    <v-card>
                      <v-card-text class="px-0 py-1">{{row.text}}</v-card-text>
                    </v-card>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </div>
          <div v-if="linksLegend.length > 0">
            <div class="text-xs-center">
              <v-subheader style="font-size: 14px !important">
                <span>Odcinki</span>
                <template v-if="displaySettings.links.attribute !== 'null'">
                  <v-btn
                    flat
                    fab
                    small
                    title="utwórz ręczną stylizację"
                    @click="editLegend('links')"
                  >
                    <v-icon dark>edit</v-icon>
                  </v-btn>
                  <v-btn
                    flat
                    fab
                    small
                    title="wyczyść ręczną stylizację"
                    @click="clearLegend('links')"
                  >
                    <v-icon dark>delete</v-icon>
                  </v-btn>
                </template>
              </v-subheader>
            </div>
            <v-container
              grid-list-md
              text-xs-center
            >
              <v-layout
                row
                wrap
              >
                <template v-for="row in linksLegend">
                  <v-flex xs2>
                    <v-card
                      dark
                      :color="row.color"
                    >
                      <v-card-text class="px-0 py-1">&nbsp;</v-card-text>
                    </v-card>
                  </v-flex>
                  <v-flex xs10>
                    <v-card>
                      <v-card-text class="px-0 py-1">{{row.text}}</v-card-text>
                    </v-card>
                  </v-flex>
                </template>
              </v-layout>
            </v-container>
          </div>
        </div>
        <div v-else>
          <p>Nie wczytano danych z modelowania</p>
        </div>
      </template>

    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";
import niceRange from "../../../../utils/niceRange.js";
window.niceRange = niceRange;

import chain from "lodash/chain";
import value from "lodash/value";
import mixin from "lodash/mixin";
import _ from "lodash/wrapperLodash";
mixin(_, {
  chain,

  eachSequence(elements, callback) {
    for(let i = 0; i < elements.length - 1; i++) {
      callback(elements[i], elements[i + 1], i, i + 1);
    }
  }
});
_.value = value;
_.prototype.value = value;

export default {
  components: {
    Modal
  },
  data: () => ({
    chosenElement: "btn--nodes",
    activeTab: undefined,
    settings: {},
    nodesLegend: [],
    linksLegend: [],

    editLegendType: false,
    editLegendValue: [],
    attributes: {
      links: {
        "flow": "Natężenie przepływu",
        "friction": "Współczynnik tarcia",
        "headloss": "Jednostkowy wskaźnik strat ciśnienia",
        "quality": "Wiek wody",
        "reactionrate": " Natężenie reakcji",
        'status': "Status przewodu",
        "velocity": "Prędkość przepływu"
      },
      nodes: {
        "demand": "Obliczone zużycie w danym momencie symulacji",
        "head": "Wysokość linii ciśnienia",
        "pressure": "Wartość ciśnienia",
        "quality": "Wiek wody"
      }
    },
    category10: [
      '#2001ff',
      '#7dfbfb',
      '#79fb17',
      '#fcfe00',
      '#e52e2d'
    ]
  }),
  computed: {
    displaySettings() {
      return this.$store.getters.getModelWatDisplaySettings;
    },
    currentZoom() {
      return this.$store.getters.getCurrentZoom;
    }
  },
  watch: {
    settings: {
      handler(_new, _old) {
        if(this.ignore) {
          this.ignore = false;
          return;
        };
        this.$store.commit(
          "setModelWatDisplaySettings",
          JSON.parse(JSON.stringify(_new))
        );
      },
      deep: true
    },
    displaySettings() {
      this.ignore = true;
      this.$set(
        this.$data,
        "settings",
        JSON.parse(JSON.stringify(this.displaySettings))
      );
      this.refreshLegend();
    }
  },
  methods: {
    setChosenElement(element) {
      if(this.chosenElement === undefined) {
        this.chosenElement = element.target.id;
      } else {
        this.chosenElement = element.target.id;
      }
    },
    opened() {
      let buttons = document
        .getElementById("displaySettingsModal")
        .querySelectorAll(".buttons--button");
      for(let i = 0; i < buttons.length; i++) {
        buttons[i].onclick = this.setChosenElement;
      }

      this.$set(
        this.$data,
        "settings",
        JSON.parse(JSON.stringify(this.displaySettings))
      );

      this.editLegendType = false;
      this.refreshLegend();
    },

    refreshLegend() {
      const last_model = this.displaySettings.last_model;

      if(last_model) {
        const links = this.displaySettings.links;
        const nodes = this.displaySettings.nodes;

        this.linksLegend = [];
        if(links.attribute !== "null") {
          const attribute = links.attribute;
          const type = 'links';

          let range = [];
          if(attribute in this.displaySettings.legend[type]) {
            range = this.displaySettings.legend[type][attribute];
          } else if('range' in last_model.ranges[type][attribute]) {
            range = last_model.ranges[type][attribute].range;
          } else {
            const min = last_model.ranges[type][attribute].min;
            const max = last_model.ranges[type][attribute].max;
            const middle_range = niceRange([min, max], 1);
            range = [Math.floor(min), ...middle_range, Math.ceil(max)];
          }

          this.linksLegend.push({
            color: this.category10[0],
            text: `<= ${range[0]}`
          });

          _.eachSequence(range, (v1, v2, k1, k2) => {
            this.linksLegend.push({
              color: this.category10[k2],
              text: `${v1} - ${v2}`
            });
          });

          this.linksLegend.push({
            color: this.category10[range.length],
            text: `>= ${range[range.length - 1]}`
          });
        } else {
          this.linksLegend.push({
            color: this.category10[0],
            text: `wszystko`
          });
        }

        this.nodesLegend = [];
        if(nodes.attribute !== "null") {
          const attribute = nodes.attribute;
          const type = 'nodes';

          let range = [];
          if(attribute in this.displaySettings.legend[type]) {
            range = this.displaySettings.legend[type][attribute];
          } else if('range' in last_model.ranges[type][attribute]) {
            range = last_model.ranges[type][attribute].range;
          } else {
            const min = last_model.ranges[type][attribute].min;
            const max = last_model.ranges[type][attribute].max;
            const middle_range = niceRange([min, max], 1);
            range = [Math.floor(min), ...middle_range, Math.ceil(max)];
          }

          this.nodesLegend.push({
            color: this.category10[0],
            text: `<= ${range[0]}`
          });

          _.eachSequence(range, (v1, v2, k1, k2) => {
            this.nodesLegend.push({
              color: this.category10[k2],
              text: `od ${v1} do ${v2}`
            });
          });

          this.nodesLegend.push({
            color: this.category10[range.length],
            text: `>= ${range[range.length - 1]}`
          });
        } else {
          this.nodesLegend.push({
            color: this.category10[0],
            text: `wszystko`
          });
        }
      }
    },

    editLegend(type) {
      const editLegendValue = [];
      const last_model = this.displaySettings.last_model;
      const attribute = this.displaySettings[type].attribute;

      this.editLegendData = {
        attribute,
        min: Math.floor(last_model.ranges[type][attribute].min),
        max: Math.ceil(last_model.ranges[type][attribute].max)
      };

      let range = [];
      if(attribute in this.displaySettings.legend[type]) {
        range = this.displaySettings.legend[type][attribute];
      } else if('range' in last_model.ranges[type][attribute]) {
        range = last_model.ranges[type][attribute].range;
      } else {
        const min = last_model.ranges[type][attribute].min;
        const max = last_model.ranges[type][attribute].max;
        const middle_range = niceRange([min, max], 1);
        range = [Math.floor(min), ...middle_range, Math.ceil(max)];
      }

      editLegendValue.push({
        color: this.category10[0],
        value: range[0]
      });

      _.eachSequence(this.category10.slice(0, 4), (v1, v2, k1, k2) => {
        editLegendValue.push({
          color: this.category10[k2],
          value: range[k2]
        });
      });

      editLegendValue.push({
        color: this.category10[4],
        value: 0
      });

      this.editLegendValue = editLegendValue;
      this.editLegendType = type;
    },
    clearLegend(type) {
      const attribute = this.displaySettings[type].attribute;
      const settings = JSON.parse(JSON.stringify(this.displaySettings));
      if(attribute in settings.legend[type]) {
        delete settings.legend[type][attribute];
        this.$store.commit("setModelWatDisplaySettings", settings);
      }
    },
    saveLegend() {
      const settings = JSON.parse(JSON.stringify(this.displaySettings));

      settings.legend[this.editLegendType][this.editLegendData.attribute] = _.map(this.editLegendValue, (v) => +v.value).slice(0, 4);
      this.$store.commit("setModelWatDisplaySettings", settings);

      this.editLegendType = false;
    }
  },
  created() {
    this.ignore = false;
    this.$set(
      this.$data,
      "settings",
      JSON.parse(JSON.stringify(this.displaySettings))
    );
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/DisplaySettings.vue